import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, User } from 'lucide-react';
import { Badge } from '../ui/badge';

const BlogCard = ({ blog }) => {
  return (
    <article 
      className="group bg-white border border-slate-200 overflow-hidden hover:shadow-xl hover:border-primary/30 transition-all duration-300"
      data-testid={`blog-card-${blog.id}`}
    >
      <Link to={`/blog/${blog.slug}`}>
        {/* Image */}
        <div className="relative h-48 overflow-hidden">
          <img 
            src={blog.image} 
            alt={blog.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-4 left-4">
            <Badge className="bg-primary text-white font-body text-xs">
              {blog.category}
            </Badge>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Meta */}
          <div className="flex items-center gap-4 mb-3 text-slate-500">
            <span className="flex items-center gap-1 font-body text-xs">
              <User className="w-3 h-3" />
              {blog.author}
            </span>
            <span className="flex items-center gap-1 font-body text-xs">
              <Clock className="w-3 h-3" />
              {blog.read_time}
            </span>
          </div>

          {/* Title */}
          <h3 className="font-heading text-lg font-semibold text-slate-800 mb-2 group-hover:text-primary transition-colors line-clamp-2">
            {blog.title}
          </h3>

          {/* Excerpt */}
          <p className="font-body text-sm text-slate-600 line-clamp-2 mb-4">
            {blog.excerpt}
          </p>

          {/* Read More */}
          <span className="flex items-center gap-1 font-body text-sm font-semibold text-primary group-hover:gap-2 transition-all">
            Read Article
            <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
